/* @ngInject */
function uiElementViewLogService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    createElementViewLog,
    getElementViewLog,
    shouldShowUiElement
  }
  return service

  function createElementViewLog (slug) {
    const payload = { slug }

    return ConnectorWebService.post(CONSTANTS.URL_UI_ELEMENT_VIEW_LOG_SLUG, payload)
  }

  function getElementViewLog (slug) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_UI_ELEMENT_VIEW_LOG_SLUG)

    if (slug) {
      url = Utils.fnAddQueryToUrl(url, { slug })
    }

    return ConnectorWebService.get(url)
  }

  /*
  * {slug} - string: unique identifier flag for this UI element
  * {count} - int: control the number of times this element should show to the user before be hidden
  */
  async function shouldShowUiElement (slug, count, userId) {
    const shouldNotShow = await getElementViewLog(slug)

    if (shouldNotShow) {
      return false
    }

    let localStorageSlug = slug
    if (userId) {
      localStorageSlug = `${slug}-${userId}`
    }

    const val = localStorage.getItem(localStorageSlug)
    if (!val) {
      localStorage.setItem(localStorageSlug, 1)
      return true
    } else if (val && parseInt(val) <= count) {
      const newVal = parseInt(val) + 1
      localStorage.setItem(localStorageSlug, newVal)

      if (newVal === count) {
        createElementViewLog(slug)
      }
      return true
    } else {
      return false
    }
  }
}

export { uiElementViewLogService }
